import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate, getTranslate } from 'react-localize-redux';
import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import ActionHandler from '../Actions/ActionHandler';
import { Redirect } from 'react-router-dom'

import { actionCreators as accountStore } from '../../store/Account';

class Home extends Component {

	navigateToExternalTarget(e, location) {
		window.open(location, "_blank")
	}

	render() {
		//console.log(this.props.navigation.menuItems);
		//if (this.props.navigation.menuItems.length === 0) return null;

		// Try to render the homepage
		for (var i in this.props.navigation.menuItems) {
			let menu = this.props.navigation.menuItems[i];
			if (menu.id > 0 && menu.isHomepage === true) {
				return <ActionHandler id={menu.actionId} />;
			}
		}

		if (this.props.account.defaultActionId) {
			return <ActionHandler id={this.props.account.defaultActionId} />
		}

		return (
			<Container fluid>
				<Row>
					<Col lg={6}>
						<Card>
							<Card.Body>
								<Card.Title>
									<Translate id="home.portalWelcome" data={{ userName: this.props.account.name }} />
								</Card.Title>
							</Card.Body>
						</Card>
					</Col>
					<Col lg={6}>
					</Col>
				</Row>
			</Container>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.account.isAuthenticated,
		translate: getTranslate(state.localize),
		account: state.account,
		navigation: state.navigation,
		defaultActionId: state.defaultActionId
	};
};


export default connect(
	mapStateToProps,
	dispatch => bindActionCreators({ ...accountStore }, dispatch)
)(Home);


// WEBPACK FOOTER //
// ./src/components/Home/Home.js